import React from "react";
import List from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText";
import CircularProgress from "@mui/material/CircularProgress";
import { FullScreenDialog } from "./FullScreenDialog";
import { CircularProgressSize } from "../theme";
import ListItem from "@mui/material/ListItem";
import Edit from "@mui/icons-material/Edit";
import Add from "@mui/icons-material/Add";

/**
 * @param {object} props
 * @param {string} props.title - Title of the dialog
 * @param {string} [props.secondary] - Secondary text to display in the dialog
 * @param {function(): void} props.handleSave - Callback when the save button is clicked
 * @param {(() => React.ReactNode)|React.ReactNode} props.OnAddOverlay - Overlay to display when adding
 * @param {boolean} props.isLoading - Whether the data is loading
 * @param {React.ReactNode} props.children - Children to display in the dialog
 * @param {boolean} [props.multiple] - Whether the dialog allows multiple selections
 * @param {number} [props.selectedCount] - Number of selected items
 */
export const SelectableListEntriesDialog = ({
  title,
  secondary = "",
  handleSave,
  OnAddOverlay,
  isLoading,
  children,
  multiple = true,
  selectedCount = 0,
}) => {
  const EditIcon = selectedCount === 0 ? Add : Edit;
  const overlay =
    typeof OnAddOverlay === "function" ? <OnAddOverlay /> : OnAddOverlay;

  return (
    <List style={{ width: "100%" }}>
      <ListItem>
        <ListItemText primary={title} secondary={secondary} />
        <FullScreenDialog
          title={title}
          canSave={false}
          actionText="SAVE"
          onSaveHandler={handleSave}
          Icon={multiple ? Add : EditIcon}
        >
          {overlay}
        </FullScreenDialog>
      </ListItem>
      {isLoading && <CircularProgress size={CircularProgressSize} />}
      {children}
    </List>
  );
};
